module.exports = __webpack_public_path__ + "img/warning.b6fb9d1.svg";